import { useMemo } from 'react';
import {
  ButtonIcon,
  FlexContainer,
  Label,
  LabelBase,
  Status,
  StatusBase,
  StatusType,
  TableLegacy,
} from '@facephi/ui-react';
import { useTranslation } from 'react-i18next';
import { fakePrivacyTable } from '../../api/fakeData';
import { useCopyToClipboard } from '../../hooks';
import { OPERATIONS_COLORS } from '../../state/constants';
import { StyledHeader, StyledPrivacyTab } from './Styles';

export const PrivacyTab = () => {
  const { t, i18n } = useTranslation();
  const { copy } = useCopyToClipboard();

  const columns = useMemo(
    () => [
      {
        Header: t('Date'),
        accessor: 'date',
        maxWidth: 200,
      },
      {
        Header: t('Operations'),
        accessor: 'operations',
      },
      {
        Header: t('code'),
        accessor: 'code',
      },
      {
        Header: t('Agent'),
        accessor: 'agent',
        maxWidth: 250,
      },
      {
        Header: t('Status'),
        accessor: 'status',
      },
      {
        Header: t('Action'),
        accessor: 'action',
        maxWidth: 100,
      },
    ],
    []
  );

  const data = fakePrivacyTable?.map((item) => ({
    date: item.date,
    operations: (
      <LabelBase
        color={OPERATIONS_COLORS[item.operations]}
        label={t(item.operations)}
      />
    ),
    code: item.code,
    agent: (
      <FlexContainer columnGap="0.8" alignItems="center">
        <FlexContainer flexDirection="column">
          <Label fontSize="10">{item.agent}</Label>
          <Label fontSize="10">{item.email}</Label>
        </FlexContainer>
        <ButtonIcon
          iconName="CopySimple"
          variant="text"
          onClick={() => copy(`${item.agent} ${item.email}`)}
        />
      </FlexContainer>
    ),
    status: (
      <Status
        status={item.status as StatusType}
        hasLabel
        locale={i18n.language}
      />
    ),
    action: <ButtonIcon iconName="Eye" variant="text" />,
  }));

  return (
    <StyledPrivacyTab flexDirection="column" flex="1" forwardedAs="section">
      {/* Header */}
      <StyledHeader forwardedAs="section" columnGap="8.8">
        <FlexContainer columnGap="0.4">
          <Label semibold fontSize="12">
            {t('User')}:
          </Label>
          <Label fontSize="12">Jose Luis Gomez Peralta</Label>
        </FlexContainer>
        <FlexContainer columnGap="1.6">
          <Label semibold fontSize="12">
            {t('Security profile')}:
          </Label>
          <Label fontSize="12" semibold color="primary400">
            {t('Careful')}
          </Label>
        </FlexContainer>
        <StatusBase color="green400" label={t('connected') as string} />
      </StyledHeader>
      {/* Table */}
      <FlexContainer as="section" flex="1">
        <TableLegacy columns={columns} data={data} hasMore={false} />
      </FlexContainer>
    </StyledPrivacyTab>
  );
};
